import { APP_INITIALIZER, InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';

import {
    InMemoryTokenStore,
    SeUiControlsModule,
    SeUiLayoutModule,
    SeUiUtilitiesModule,
    TokenStoreInjector,
} from '@se/se.ui.html5';

import { SeUiAdvancedModule } from '@se/se.ui.advanced';

import { HeaderInformationComponent } from './header-information/header-information.component';

// #region AngularJS Services
import { EstensaServiceLocator } from './services/angularjs/estensa-locator.service';
import { ESTENSA_MODULE_AUTHENTICATION_SERVICE } from './services/authentication/authentication.service';
import { ESTENSA_MODULE_BUS_SERVICE, NullBusService } from './services/angularjs/estensa-bus-wrapper.service';
import { ESTENSA_MODULE_MODAL_SPINNER_SERVICE } from './services/angularjs/modal-spinner.service';
import {
    ESTENSA_MODULE_PRINT_CONFIGURATION_SERVICE,
    EstensaPrintService,
    PrintPdfService,
} from './services/angularjs/estensa-print.service';
import { ESTENSA_MODULE_PATIENT_SERVICE } from './services/angularjs/estensa-patient.service';
import {
    ESTENSA_MODULE_PATIENT_FOLDER_SERVICE,
    NullPatientFolderService,
} from './services/angularjs/estensa-patient-folder.service';
import { ESTENSA_MODULE_EXTERNAL_DOCS_SERVICE } from './services/angularjs/estensa-external-docs.service';
import {
    ESTENSA_MODULE_THIRD_PART_POST_MESSAGE_SERVICE,
    NullThirdPartPostMessageService,
    ThirdPartPostMessageService,
} from './services/third-part-post-message.service';

import {
    ESTENSA_MODULE_THIRD_PART_SUPPORT_SERVICE,
    NullThirdPartSupportService,
    ThirdPartSupportService,
} from './services/third-part-support.service';

import { ESTENSA_MODULE_RECONICE_SERVICE, NullReconiceService } from './services/angularjs/estensa-reconice.service';
import {
    ESTENSA_MODULE_SPEECH_MODAL_SERVICE,
    NullSpeechModalService,
} from './services/angularjs/estensa-speech-modal.service';

// #endregion
// #region Sign
import { SignAuthDialogComponent } from './sign/sign-auth-dialog/sign-auth-dialog.component';

// #endregion
// #region Confirm
import { ConfirmDialogComponent } from './confirm/confirm-dialog/confirm-dialog.component';

// #endregion
// #region
import { PdfViewerModule } from 'ng2-pdf-viewer';

import { PdfModalComponent } from './pdf-modal/pdf-modal.component';

// #endregion
// #region External Docs
import { SeExternalDocsDialogComponent } from './se-external-docs/se-external-docs-dialog.component';
import { SeExternalDocsTreeComponent } from './se-external-docs/se-external-docs-tree/se-external-docs-tree.component';
import { SeExternalDocsEditorComponent } from './se-external-docs/se-external-docs-editor/se-external-docs-editor.component';
import { SeExternalDocsMessageComponent } from './se-external-docs/se-external-docs-message/se-external-docs-message.component';

// #endregion
// #region Reporting
import {
    NullReportWorkflowExamService,
    REPORT_WORKFLOW_EXAM_SERVICE_TOKEN,
} from './services/report-workflow-exam.service';

// #endregion
// #region AngularJS
import {
    ESTENSA_MODULE_COMMON_APPLICATION_SETTINGS_SERVICE,
    NullCommonApplicationSettingsService,
} from './services/settings/common-application-settings.service';
import { ESTENSA_MODULE_COMMON_SETTINGS_SERVICE } from './services/settings/common-settings.service';
import { ESTENSA_MODULE_PATIENT_SETTINGS_SERVICE } from './services/settings/patient-settings.service';
import { ESTENSA_MODULE_RADIO_SETTINGS_SERVICE } from './services/settings/radio-settings.service';
import {
    ESTENSA_MODULE_NOTIFICATION_SERVICE,
    NullNotificationService,
} from './services/angularjs/estensa-notification.service';
import { ESTENSA_MODULE_SECONDARY_APPLICATION_SETTINGS_SERVICE } from './services/settings/secondary-application-settings.service';
import { ESTENSA_MODULE_SEVERAL_SETTINGS_BOX_SETTINGS_SERVICE } from './services/settings/several-settings-box-settings.service.';
import { ESTENSA_MODULE_SPECIALIZED_CLIENT_APPLICATION_SETTINGS_SERVICE } from './services/settings/specialized-client-application-settings.service';
import {
    ESTENSA_MODULE_USER_CONFIGURATION_SETTINGS_SERVICE,
    NullUserConfigurationSettingsService,
} from './services/settings/user-configuration-settings.service';
import { BROKER_MODULE_BROKER_CHECK_SERVICE, NullBrokerCheckService } from './services/angularjs/broker-check.service';
import { NullImagingService, RADIOLOGY_API_CLIENT_IMAGING_SERVICE } from './services/imaging/common';
import {
    ESTENSA_MODULE_IS_INTEGRATION_SERVICE,
    NullIsIntegrationWebService,
} from './connectivity/is-integration-web.service';
import { ESTENSA_MODULE_BUTTONS_SERVICE, NullButtonsService } from './services/angularjs/estensa-buttons.service';
import { ESTENSA_NOTIFICATION_AUTHENTICATED_HUB_SERVICE } from './services/angularjs/estensa-notification-authenticated-hub.service';

// #endregion
// #region Search
import { DiffHeaderComponent } from './search-page/search-result/header-renders/diff-header/diff-header.component';

import { SearchContainerComponent } from './search-page/search-container/search-container.component';
import { SearchFilterComponent } from './search-page/search-filter/search-filter.component';
import { SearchResultComponent } from './search-page/search-result/search-result.component';
import { BoolIconRendererComponent } from './search-page/search-result/cell-renderers/bool-icon-renderer/bool-icon-renderer.component';
import { StateIconRendererComponent } from './search-page/search-result/cell-renderers/state-icon-renderer/state-icon-renderer.component';
import { LockUnlockRendererComponent } from './search-page/search-result/cell-renderers/lock-unlock-renderer/lock-unlock-renderer.component';
import { SuccessFailureRendererComponent } from './search-page/search-result/cell-renderers/success-failure-renderer/success-failure-renderer.component';
import { PrintingCdStatusRendererComponent } from './search-page/search-result/cell-renderers/printing-cd-status-renderer/printing-cd-status-renderer.component';

// #endregion
// #region Toolbar
import { SeButtonsToolbarComponent } from './se-toolbar/se-buttons-toolbar/se-buttons-toolbar.component';
import { SeHeaderToolbarComponent } from './se-toolbar/se-header-toolbar/se-header-toolbar.component';
import { SeHeaderOptionsComponent } from './se-toolbar/se-header-toolbar/se-header-options/se-header-options.component';
import { SeHeaderNotificationComponent } from './se-toolbar/se-header-toolbar/se-header-notification/se-header-notification.component';
import { SeHeaderInfoComponent } from './se-toolbar/se-header-toolbar/se-header-info/se-header-info.component';
import { SeHeaderUserInfoComponent } from './se-toolbar/se-header-toolbar/se-header-user-info/se-header-user-info.component';
import { SeHeaderAboutComponent } from './se-toolbar/se-header-toolbar/se-header-about/se-header-about.component';
import { SeHeaderConnectivityComponent } from './se-toolbar/se-header-toolbar/se-header-connectivity/se-header-connectivity.component';
import {
    ESTENSA_MODULE_RADIOLOGY_COMMON_SERVICE,
    NullRadiologyCommonService,
} from './services/angularjs/radiology-common.service';

import { SeSharedModule } from './shared.module';

// #endregion
// #region Side navigator
import { SeSideNavComponent } from './se-side/se-side-nav/se-side-nav.component';
import { SeSidePatientHistoryComponent } from './se-side/se-side-components/se-side-patient-history/se-side-patient-history.component';
import { SeSidePatientHistoryItemComponent } from './se-side/se-side-components/se-side-patient-history/se-side-patient-history-item/se-side-patient-history-item.component';
import { SeSideKeyImagesContainerComponent } from './se-side/se-side-components/se-side-key-images-container/se-side-key-images-container.component';
import { SeSideKeyImagesItemComponent } from './se-side/se-side-components/se-side-key-images-container/se-side-key-images-item/se-side-key-images-item.component';

//#endregion
import { NavigationBrowserService } from './services/navigation-browser.service';
import {
    ESTENSA_MODULE_HEALTH_PLATFORM_SERVICE,
    NullEstensaHealthPlatformService,
} from './services/angularjs/health-platform.service';
import { EffectsModule } from '@ngrx/effects';
import { ReportEffects } from './report/report.effects';
import { StoreProvider } from '@se/ecg.viewer.html5';
import { StackManagerComponent } from './services/tp-integrations/stack-manager/stack-manager.component';
import { RestCallComponent } from './services/tp-integrations/stack-manager/rest-call/rest-call.component';
import { IframeCallComponent } from './services/tp-integrations/stack-manager/iframe-call/iframe-call.component';
import { TpIntegrationsService } from './services/tp-integrations/tp-integrations.service';
import { ErrorCallComponent } from './services/tp-integrations/stack-manager/error-call/error-call.component';
import { ArrayFindCallComponent } from './services/tp-integrations/stack-manager/array-find-call/array-find-call.component';
import { TabWindowCallComponentComponent } from './services/tp-integrations/stack-manager/tab-window-call-component/tab-window-call-component.component';
import { EstensaReviewConfirmationModalComponent } from './services/imaging/estensa-review-confirmation-modal.component';
import { BROKER_MODULE_BROKER_SERVICE, NullBrokerService } from './services/angularjs/broker.service';
import { MultiConfirmDialogComponent } from './confirm/multi-confirm-dialog/multi-confirm-dialog.component';
import { MultiSignAuthDialogComponent } from './sign/multi-sign-auth-dialog/multi-sign-auth-dialog.component';
import { ApSearchFilterComponent } from './search-page/ap-search-filter/ap-search-filter.component';
import { SearchResultFooterComponent } from './search-page/search-result-footer/search-result-footer.component';
import { SeSideDetailsComponent } from './se-side/se-side-components/se-side-details/se-side-details.component';
import { ApSearchContainerComponent } from './search-page/ap-search-container/ap-search-container.component';
import { SeSearchSettingsComponent } from './se-search-settings/se-search-settings.component';
import { SeSearchFooterToolbarComponent } from './se-search-footer-toolbar/se-search-footer-toolbar.component';
import { SeSideDetailsItemComponent } from './se-side/se-side-components/se-side-details/se-side-details-item/se-side-details-item.component';
import { SeSideDetailsNoteComponent } from './se-side/se-side-components/se-side-details/se-side-details-note/se-side-details-note.component';
import { ImportIconRendererComponent } from './search-page/search-result/cell-renderers/import-icon-renderer/import-icon-renderer.component';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { SeSettingsMenuComponent } from './se-search-settings/se-settings-menu/se-settings-menu.component';
import { ApFiltersRowComponent } from './search-page/ap-search-filter/ap-filters-row/ap-filters-row.component';
import { SeStepperComponent } from './se-stepper/components/se-stepper.component';
import { SeStepComponent } from './se-stepper/components/se-step/se-step.component';
import {
    ESTENSA_MODULE_AUTHENTICATION_SSO_SERVICE,
    NullAuthenticationSSOService,
} from './services/angularjs/authentication-sso.service';
import { SissCloudLoadingComponent } from './sign/siss-cloud/siss-cloud-loading/siss-cloud-loading.component';
import { SissCloudEffects } from './sign/siss-cloud/siss-cloud.effects';
import { ApSearchFiltersConfigComponent } from './search-page/ap-search-filter/ap-search-filters-config/ap-search-filters-config.component';
import { ApSearchFiltersConfigVisibilityComponent } from './search-page/ap-search-filter/ap-search-filters-config-visibility/ap-search-filters-config-visibility.component';
import { AssociatedVisitRendererComponent } from './search-page/search-result/cell-renderers/associated-visit-renderer/associated-visit-renderer.component';
import { provideMockRadioSettingsService } from '@se/tests/mocks/radio-settings.service';
import { SeStepperSideNavFormdataComponent } from './se-stepper-side-nav/se-stepper-side-nav-formdata/se-stepper-side-nav-formdata.component';
import { SeStepperSideNavExamsComponent } from './se-stepper-side-nav/se-stepper-side-nav-exams/se-stepper-side-nav-exams.component';
import { SeStepperSideNavComponent } from './se-stepper-side-nav/se-stepper-side-nav.component';
import { SeStepperSideNavDetailsComponent } from './se-stepper-side-nav/se-stepper-side-nav-details/se-stepper-side-nav-details.component';
import { SeTimelineComponent } from './se-timeline/se-timeline.component';
import { SeTimelineDetailsComponent } from './se-timeline/se-timeline-details/se-timeline-details.component';
import { SeTimelineFiltersComponent } from './se-timeline/se-timeline-filters/se-timeline-filters.component';
import { DeleteExamDialogComponent } from './confirm/delete-exam-dialog/delete-exam-dialog.component';
import { SeTimelineToggleComponent } from "./se-timeline/se-timeline-toggle/se-timeline-toggle.component";
import { FormCallComponent } from './services/tp-integrations/stack-manager/form-call/form-call.component';
import { SeImageTooltipDirective } from './se-image-tooltip/se-image-tooltip.directive';


export const LOCATION_TOKEN = new InjectionToken<Location>('LocationToken');

@NgModule({
    declarations: [
        HeaderInformationComponent,
        SignAuthDialogComponent,
        MultiSignAuthDialogComponent,
        ConfirmDialogComponent,
        MultiConfirmDialogComponent,
        DeleteExamDialogComponent,
        SeHeaderUserInfoComponent,
        SeButtonsToolbarComponent,
        SeHeaderToolbarComponent,
        SeHeaderOptionsComponent,
        SeHeaderNotificationComponent,
        SeHeaderInfoComponent,
        SeHeaderAboutComponent,
        SearchContainerComponent,
        SearchFilterComponent,
        SearchResultComponent,
        DiffHeaderComponent,
        BoolIconRendererComponent,
        StateIconRendererComponent,
        LockUnlockRendererComponent,
        SeImageTooltipDirective,
        SeSideNavComponent,
        SeSidePatientHistoryComponent,
        SeSidePatientHistoryItemComponent,
        SeSideKeyImagesContainerComponent,
        SeSideKeyImagesItemComponent,
        PdfModalComponent,
        SeExternalDocsDialogComponent,
        SeExternalDocsTreeComponent,
        SeExternalDocsEditorComponent,
        SeExternalDocsMessageComponent,
        SuccessFailureRendererComponent,
        PrintingCdStatusRendererComponent,
        SeHeaderConnectivityComponent,
        StackManagerComponent,
        RestCallComponent,
        FormCallComponent,
        ArrayFindCallComponent,
        IframeCallComponent,
        ErrorCallComponent,
        TabWindowCallComponentComponent,
        EstensaReviewConfirmationModalComponent,
        ApSearchContainerComponent,
        ApSearchFilterComponent,
        ApFiltersRowComponent,
        SearchResultFooterComponent,
        SeSideDetailsComponent,
        SeSearchSettingsComponent,
        SeSettingsMenuComponent,
        SeSearchFooterToolbarComponent,
        SeSideDetailsItemComponent,
        SeSideDetailsNoteComponent,
        ImportIconRendererComponent,
        SeStepperComponent,
        SeStepComponent,
        SissCloudLoadingComponent,
        ApSearchFiltersConfigComponent,
        ApSearchFiltersConfigVisibilityComponent,
        AssociatedVisitRendererComponent,
        SeStepperSideNavComponent,
        SeStepperSideNavFormdataComponent,
        SeStepperSideNavExamsComponent,
        SeStepperSideNavDetailsComponent,
        SeTimelineComponent,
        SeTimelineDetailsComponent,
        SeTimelineFiltersComponent,
        SeTimelineToggleComponent
    ],
    imports: [
        SeSharedModule,
        SeUiUtilitiesModule,
        SeUiLayoutModule,
        SeUiControlsModule,
        SeUiAdvancedModule,
        PdfViewerModule,
        EffectsModule.forFeature([ReportEffects, SissCloudEffects]),
    ],
    exports: [
        HeaderInformationComponent,
        SignAuthDialogComponent,
        MultiSignAuthDialogComponent,
        ConfirmDialogComponent,
        MultiConfirmDialogComponent,
        DeleteExamDialogComponent,
        SeHeaderUserInfoComponent,
        SeButtonsToolbarComponent,
        SeHeaderToolbarComponent,
        SeHeaderOptionsComponent,
        SeHeaderInfoComponent,
        SeHeaderNotificationComponent,
        SeHeaderAboutComponent,
        SearchContainerComponent,
        SearchFilterComponent,
        SearchResultComponent,
        SeImageTooltipDirective,
        SeSideNavComponent,
        SeSidePatientHistoryComponent,
        SeSidePatientHistoryItemComponent,
        SeSideKeyImagesContainerComponent,
        SeSideKeyImagesItemComponent,
        PdfModalComponent,
        SeExternalDocsDialogComponent,
        SeExternalDocsTreeComponent,
        SeExternalDocsEditorComponent,
        SeExternalDocsMessageComponent,
        SeSearchSettingsComponent,
        SeSettingsMenuComponent,
        SeSearchFooterToolbarComponent,
        ApSearchContainerComponent,
        ApSearchFilterComponent,
        SeSideDetailsItemComponent,
        SeSideDetailsNoteComponent,
        ImportIconRendererComponent,
        SeStepperComponent,
        SeStepComponent,
        SissCloudLoadingComponent,
        SeStepperSideNavComponent,
        SeStepperSideNavFormdataComponent,
        SeStepperSideNavExamsComponent,
        SeStepperSideNavDetailsComponent,
        SeTimelineComponent,
        SeTimelineDetailsComponent,
        SeTimelineFiltersComponent,
        SeTimelineToggleComponent
    ],
    providers: [],
})
export class SePlatformModule {
    static forHybrid () : ModuleWithProviders<SePlatformModule> {
        return {
            ngModule: SePlatformModule,
            providers: [
                {
                    provide: APP_INITIALIZER,
                    multi: true,
                    useFactory: (tpIntegrations: TpIntegrationsService) => () => tpIntegrations.init(),
                    deps: [TpIntegrationsService],
                },
                {
                    provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
                    useValue: {
                        subscriptSizing: 'dynamic',
                    },
                },
                {
                    provide: APP_INITIALIZER,
                    multi: true,
                    useFactory: platformInitializerFactory,
                    deps: [NavigationBrowserService, ThirdPartPostMessageService, ThirdPartSupportService],
                },
                {
                    provide: LOCATION_TOKEN,
                    useValue: window.location,
                },
                {
                    provide: ESTENSA_MODULE_BUS_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: EstensaBusServiceFactory,
                },
                {
                    provide: ESTENSA_MODULE_AUTHENTICATION_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: AuthenticationServiceFactory,
                },
                {
                    provide: ESTENSA_MODULE_BUTTONS_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: ButtonsServiceFactory,
                },
                {
                    provide: ESTENSA_MODULE_MODAL_SPINNER_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: ProgressBarServiceFactory,
                },
                {
                    provide: BROKER_MODULE_BROKER_CHECK_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: BrokerCheckServiceFactory,
                },
                {
                    provide: BROKER_MODULE_BROKER_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: BrokerServiceFactory,
                },
                {
                    provide: RADIOLOGY_API_CLIENT_IMAGING_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: ImagingServiceFactory,
                },
                // Settings
                {
                    provide: ESTENSA_MODULE_COMMON_APPLICATION_SETTINGS_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: CommonApplicationSettingsServiceFactory,
                },
                {
                    provide: ESTENSA_MODULE_COMMON_SETTINGS_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: CommonSettingsServiceFactory,
                },
                {
                    provide: ESTENSA_MODULE_PATIENT_SETTINGS_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: PatientSettingsServiceFactory,
                },
                {
                    provide: ESTENSA_MODULE_RADIO_SETTINGS_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: RadioSettingsServiceFactory,
                },
                {
                    provide: ESTENSA_MODULE_NOTIFICATION_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: EstensaNotificationServiceFactory,
                },
                {
                    provide: ESTENSA_MODULE_IS_INTEGRATION_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: IsIntegrationWebServiceFactory,
                },
                {
                    provide: ESTENSA_MODULE_SECONDARY_APPLICATION_SETTINGS_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: SecondaryApplicationSettingsServiceFactory,
                },
                {
                    provide: ESTENSA_MODULE_SEVERAL_SETTINGS_BOX_SETTINGS_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: SeveralSettingsBoxSettingsServiceFactory,
                },
                {
                    provide: ESTENSA_MODULE_SPECIALIZED_CLIENT_APPLICATION_SETTINGS_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: SpecializedClientApplicationSettingsServiceFactory,
                },
                {
                    provide: ESTENSA_MODULE_USER_CONFIGURATION_SETTINGS_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: UserConfigurationServiceFactory,
                },
                {
                    provide: ESTENSA_MODULE_RADIOLOGY_COMMON_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: RadiologyCommonServiceFactory,
                },
                {
                    provide: ESTENSA_MODULE_PRINT_CONFIGURATION_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: PrintConfigurationServiceFactory,
                },
                {
                    provide: ESTENSA_MODULE_EXTERNAL_DOCS_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: ExternalDocsServiceFactory,
                },
                {
                    provide: PrintPdfService,
                    useClass: EstensaPrintService,
                },
                {
                    provide: ESTENSA_MODULE_PATIENT_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: PatientServiceFactory,
                },
                {
                    provide: ESTENSA_MODULE_PATIENT_FOLDER_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: PatientFolderServiceFactory,
                },
                {
                    provide: ESTENSA_NOTIFICATION_AUTHENTICATED_HUB_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: NotificationAuthenticatedHubServiceFactory,
                },
                {
                    provide: ESTENSA_MODULE_HEALTH_PLATFORM_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: HealthPlatformServiceFactory,
                },
                {
                    provide: ESTENSA_MODULE_THIRD_PART_POST_MESSAGE_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: ThirdPartPostMessageServiceFactory,
                },
                {
                    provide: ESTENSA_MODULE_THIRD_PART_SUPPORT_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: ThirdPartSupportServiceFactory,
                },
                {
                    provide: TokenStoreInjector,
                    useClass: InMemoryTokenStore,
                },
                {
                    provide: ESTENSA_MODULE_RECONICE_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: RecomedConfigurationServiceFactory,
                },
                {
                    provide: ESTENSA_MODULE_SPEECH_MODAL_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: SpeechModalServiceFactory,
                },
                {
                    provide: ESTENSA_MODULE_AUTHENTICATION_SSO_SERVICE,
                    deps: [EstensaServiceLocator],
                    useFactory: AuthenticationSSOServiceFactory,
                },
            ],
        };
    }

    static forVNext () : ModuleWithProviders<SePlatformModule> {
        return {
            ngModule: SePlatformModule,
            providers: [
                {
                    provide: APP_INITIALIZER,
                    multi: true,
                    useFactory: platformInitializerFactory,
                    deps: [NavigationBrowserService, ThirdPartPostMessageService, ThirdPartSupportService],
                },
                {
                    provide: BROKER_MODULE_BROKER_CHECK_SERVICE,
                    useClass: NullBrokerCheckService,
                },
                {
                    provide: BROKER_MODULE_BROKER_SERVICE,
                    useClass: NullBrokerService,
                },
                {
                    provide: ESTENSA_MODULE_BUTTONS_SERVICE,
                    useClass: NullButtonsService,
                },
                {
                    provide: ESTENSA_MODULE_BUS_SERVICE,
                    useClass: NullBusService,
                },
                {
                    provide: ESTENSA_MODULE_NOTIFICATION_SERVICE,
                    useClass: NullNotificationService,
                },
                {
                    provide: RADIOLOGY_API_CLIENT_IMAGING_SERVICE,
                    useClass: NullImagingService,
                },
                {
                    provide: ESTENSA_MODULE_USER_CONFIGURATION_SETTINGS_SERVICE,
                    useClass: NullUserConfigurationSettingsService,
                },
                {
                    provide: ESTENSA_MODULE_COMMON_APPLICATION_SETTINGS_SERVICE,
                    useClass: NullCommonApplicationSettingsService,
                },
                provideMockRadioSettingsService(),
                {
                    provide: ESTENSA_MODULE_RADIOLOGY_COMMON_SERVICE,
                    useClass: NullRadiologyCommonService,
                },
                {
                    provide: ESTENSA_MODULE_IS_INTEGRATION_SERVICE,
                    useClass: NullIsIntegrationWebService,
                },
                {
                    provide: REPORT_WORKFLOW_EXAM_SERVICE_TOKEN,
                    useClass: NullReportWorkflowExamService,
                },
                {
                    provide: ESTENSA_MODULE_HEALTH_PLATFORM_SERVICE,
                    useClass: NullEstensaHealthPlatformService,
                },
                {
                    provide: ESTENSA_MODULE_THIRD_PART_POST_MESSAGE_SERVICE,
                    useClass: NullThirdPartPostMessageService,
                },
                {
                    provide: ESTENSA_MODULE_THIRD_PART_SUPPORT_SERVICE,
                    useClass: NullThirdPartSupportService,
                },
                {
                    provide: ESTENSA_MODULE_PATIENT_FOLDER_SERVICE,
                    useClass: NullPatientFolderService,
                },
                {
                    provide: ESTENSA_MODULE_RECONICE_SERVICE,
                    useClass: NullReconiceService,
                },
                {
                    provide: ESTENSA_MODULE_SPEECH_MODAL_SERVICE,
                    useClass: NullSpeechModalService,
                },
                {
                    provide: ESTENSA_MODULE_AUTHENTICATION_SSO_SERVICE,
                    useClass: NullAuthenticationSSOService,
                },
                StoreProvider,
            ],
        };
    }
}

export function platformInitializerFactory (
    navigationBrowserService : NavigationBrowserService,
    thirdPartService : ThirdPartPostMessageService,
) {
    window['pdfWorkerSrc']  = (window['app_base_href'] ?? '/') + 'pdf.worker.js';

    return () => {
        navigationBrowserService.init();
        thirdPartService.initService();
    };
}

export function EstensaBusServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('EstensaBusService');
}

export function CommonApplicationSettingsServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('CommonApplicationSettingsService');
}

export function TitleServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('TitleService');
}

export function AuthenticationServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('AuthenticationService');
}

export function AuthenticationSSOServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('AuthenticationSSOService');
}

export function ButtonsServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('ButtonsService');
}

export function ProgressBarServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('ProgressBarService');
}

export function BrokerCheckServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('BrokerCheckService');
}

export function BrokerServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('BrokerService');
}

export function ImagingServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('ImagingService');
}

export function CommonSettingsServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('CommonSettingsService');
}

export function PatientSettingsServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('PatientSettingsService');
}

export function RadioSettingsServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('RadioSettingsService');
}

export function EstensaNotificationServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('EstensaNotificationService');
}

export function IsIntegrationWebServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('IsIntegrationWebService');
}

export function SecondaryApplicationSettingsServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('SecondaryApplicationSettingsService');
}

export function SeveralSettingsBoxSettingsServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('SeveralSettingsBoxSettingsService');
}

export function SpecializedClientApplicationSettingsServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('SpecializedClientApplicationSettingsService');
}

export function UserConfigurationServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('UserConfigurationService');
}

export function PrintConfigurationServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('PrintConfigService');
}

export function RadiologyCommonServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('RadiologyCommonService');
}

export function PatientServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('PatientService');
}

export function PatientFolderServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('PatientFolderService');
}

export function ExternalDocsServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('ExternalDocsService');
}

export function NotificationAuthenticatedHubServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('NotificationAuthenticatedHubService');
}

export function HealthPlatformServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('HealthPlatformService');
}

export function ThirdPartPostMessageServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('ThirdPartPostMessageService');
}

export function ThirdPartSupportServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('ThirdPartSupportService');
}

export function RecomedConfigurationServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('RecomedConfigurationService');
}

export function SpeechModalServiceFactory (estensaServiceLocator : EstensaServiceLocator) {
    return estensaServiceLocator.getService('SpeechModalService');
}
